import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import modules from './modules';

const multibookConfig = require(`../../package.json`).config;
if (multibookConfig.launcherType === 'book' && multibookConfig.external) {
  for (const multibookType of multibookConfig.external) {
    let staticModule = require('./templates/module_template.js').default(multibookType);
    modules[`${_.upperFirst(multibookType)}`] = staticModule;
  }
} else if (multibookConfig.launcherType === 'grid') {
  let staticModule = require('./templates/module_template_grid.js').default(multibookConfig.type);
  modules[`${_.upperFirst(multibookConfig.type)}`] = staticModule;
} else {
  let staticModule = require('./templates/module_template.js').default(multibookConfig.type);
  modules[`${_.upperFirst(multibookConfig.type)}`] = staticModule;
}

// modules = Object.assign({}, modules);
Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  // plugins: [createPersistedState(), createSharedMutations()],
  strict: process.env.NODE_ENV !== 'production',
});
